function init_header() {
  /*Header Fix
------------------------------*/
  if (document.documentElement.clientWidth > 800) {
    var $menu = $("#headwrap"),
      _top = $menu.offset().top;

    var $win = $(window).scroll(function () {
      if ($win.scrollTop() >= _top + 30) {
        $("#headwrap").addClass("mini-header");
      } else {
        $("#headwrap").removeClass("mini-header");
      }
    });
  }
  /*Menu
  ------------------------------*/
  /*$(".toggle-nav").click(function(){
    $(this).toggleClass("active");
    $(".main-nav").animate({left:"0px"});
    $(".overlay").fadeIn(300);
  });
  $(".active").click(function(){
    $(".main-nav").animate({left:"-348px"});
    $(".overlay").fadeOut(300);
    $(".active").removeClass("active");
  });*/

  $(".sub-nav-category .containwrap ul li").click(function () {
    var allw = $(".sub-nav-category .containwrap").width();
    var itemw = $(".sub-nav-category .containwrap ul").width() + allw / 3.5;
    $(".sub-nav-item").css({
      "width": itemw
    });

    if ($(this).find('.sub-nav-item').length !== 0) {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(".sub-nav-category").css({
          "border-bottom": "1px solid #fff"
        });
      } else {
        $('.sub-nav-category .containwrap ul li').not(this).removeClass('active');
        $(this).addClass('active');
        $(".sub-nav-category").css({
          "border-bottom": "1px solid #eee"
        });
      };
    };
  });


  /*if($('.sub-nav-category .containwrap ul li').hasClass('active')){
    $('.sub-nav-category .containwrap ul li').click(function(){
      $(this).removeClass('active');
    });
  }else{
    $('.sub-nav-category .containwrap ul li').click(function(){
      $('.sub-nav-category .containwrap ul li').not(this).removeClass('active');
      $(this).addClass('active');
    });
  };*/

  (function ($) {
    $.fn.clickToggle = function (func1, func2) {
      var funcs = [func1, func2];
      this.data('toggleclicked', 0);
      this.click(function () {
        var data = $(this).data();
        var tc = data.toggleclicked;
        $.proxy(funcs[tc], this)();
        data.toggleclicked = (tc + 1) % 2;
      });
      return this;
    };
  }(jQuery));

  $('.toggle-nav').clickToggle(function () {
      $(this).toggleClass('active');
      $('.main-nav').animate({
        left: '0px'
      });
      $('.overlay').fadeIn(300);
    },
    function () {
      $('.main-nav').animate({
        left: '-348px'
      });
      $('.overlay').fadeOut(300);
      $(this).removeClass('active');
      $('.accordion-body').find('.niv2').removeClass('open');
      $('.accordion-body').find('.side-menu-level2').removeClass('actif');
    });

  /*$('.sub-nav-category .containwrap ul li').clickToggle(function() {
    $('.sub-nav-category .containwrap ul li').not(this).removeClass('active');
    $(this).addClass('active');
  },
  function() {
    $('.sub-nav-category .containwrap ul li').removeClass('active');
  });*/

  $('.main-nav .accordion-heading .accordion-toggle').click(function () {
    $('.accordion-heading .accordion-toggle').removeClass('active');
    $(this).addClass('active');
    $('.accordion-body').find('.niv2').removeClass('open');
    $('.accordion-body').find('.side-menu-level2').removeClass('actif');

    /*$('.panel-title').removeClass('actives'); 
    $(this).parent().addClass('actives'); 
    
    alert($(this).parents('.panel-heading').attr('class'));*/
  });

  $('.side-menu-level2').clickToggle(function () {
      $(this).next('.niv2').toggleClass('open');
      $(this).toggleClass('actif');
    },
    function () {
      $(this).next('.niv2').removeClass('open');
      $(this).removeClass('actif');
    });

  $('.overlay').click(function () {
    $('.main-nav').animate({
      left: '-348px'
    });
    $('.overlay').fadeOut(300);
    $('.toggle-nav').removeClass('active');
    $('.side-menu-level2').next('.niv2').removeClass('open');
    $('.side-menu-level2').removeClass('actif');
  });

  $('.btn-close').click(function () {
    $('.accordion-body').find('.niv2').removeClass('open');
    $('.accordion-body').find('.side-menu-level2').removeClass('actif');
  });

  $('.accordion-toggle.collapsed').on('click', (e) => {
    e.preventDefault();
    let t = $(e.currentTarget);
    let target = t.attr('href');
    $(target).toggleClass('open');
  })
}